import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryListComponent } from './history-list/history-list.component';
import { HistoryService } from '@fi-app/history/history.service';
import { UIRouterModule } from '@uirouter/angular';
import { HistoryStates } from '@fi-app/history/history-states';
import { ComponentsModule } from '@fi-app/components/components.module';
import { FiStateSrefModule } from '@fi-app/shared/fi-state-proxy/state-sref/state-sref.module';
import { HistoryListActionColumnComponent } from './history-list/history-list-action-column/history-list-action-column.component';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { MatCardModule } from '@angular/material/card';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';

@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        UIRouterModule.forChild(HistoryStates),
        FiStateSrefModule,
        FiWrapperTableModule,
        FiWhenScrolledModule,
        FiAppTextSharedModule,
        FiLocalSearch2Module,
        MatCardModule,
        FiFormatDateModule,
    ],
    declarations: [HistoryListComponent, HistoryListActionColumnComponent],
    providers: [HistoryService],
})
export class HistoryModule {}
